import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { isEqualProductsCount } from './isEqualProductsCount'

interface IIsCategoryChecked {
  selectedData: ICategorySoldProducts[]
  categoryKey: string
  staticData: ICategorySoldProducts[]
}
export const isCategoryChecked = ({
  selectedData,
  categoryKey,
  staticData,
}: IIsCategoryChecked) => {
  if (!selectedData) {
    return false
  }

  return isEqualProductsCount({ staticData, categoryKey, selectedData })
}
